import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SeoHead from '../../components/feature/SeoHead';

const CleanPassPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    telephone: '',
    email: '',
    marque: '',
    modele: '',
    categorie: '',
    formule: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      // Envoi du formulaire Readdy
      const formDataToSend = new URLSearchParams();
      formDataToSend.append('nom', formData.nom);
      formDataToSend.append('prenom', formData.prenom);
      formDataToSend.append('telephone', formData.telephone);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('marque', formData.marque);
      formDataToSend.append('modele', formData.modele);
      formDataToSend.append('categorie', formData.categorie);
      formDataToSend.append('formule', formData.formule);
      formDataToSend.append('message', formData.message);

      await fetch('https://readdy.ai/api/form/d6jnqjqpaf6ievb71iu0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formDataToSend.toString()
      });

      // Envoi des emails via la fonction dédiée CleanPass
      const emailResponse = await fetch(
        'https://vgkcneqvrkjhfnogjown.supabase.co/functions/v1/send-cleanpass-notification',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            prenom: formData.prenom,
            nom: formData.nom,
            email: formData.email,
            telephone: formData.telephone,
            marque: formData.marque,
            modele: formData.modele,
            categorie: formData.categorie,
            formule: formData.formule,
            message: formData.message,
          }),
        }
      );

      if (emailResponse.ok) {
        setSubmitStatus('success');
        setFormData({
          nom: '',
          prenom: '',
          telephone: '',
          email: '',
          marque: '',
          modele: '',
          categorie: '',
          formule: '',
          message: ''
        });
        setTimeout(() => {
          setIsModalOpen(false);
          setSubmitStatus('idle');
        }, 3000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Erreur lors de l\'envoi:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.louatiautocenter.ch';

  return (
    <div className="min-h-screen bg-dark-bg">
      <SeoHead
        title="CleanPass – Abonnement Entretien Véhicule Payerne | Louati AUTOCENTER"
        description="CleanPass : abonnement entretien automobile à Payerne. Formules Essential 79 CHF, Plus 149 CHF, Elite 249 CHF/mois. Véhicule toujours propre, priorité rendez-vous, réductions exclusives."
        keywords="abonnement entretien voiture Payerne, CleanPass auto Suisse, nettoyage régulier véhicule, abonnement lavage auto"
        canonical={`${siteUrl}/cleanpass`}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "CleanPass – Abonnement Entretien Véhicule Payerne | Louati AUTOCENTER",
            "description": "Abonnement entretien automobile à Payerne. Formules Essential, Plus et Elite disponibles.",
            "url": `${siteUrl}/cleanpass`,
            "inLanguage": "fr-CH",
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Accueil", "item": `${siteUrl}/` },
                { "@type": "ListItem", "position": 2, "name": "CleanPass", "item": `${siteUrl}/cleanpass` }
              ]
            }
          },
          {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": "CleanPass – Abonnement Entretien Automobile",
            "description": "Programme d'abonnement pour garder votre véhicule propre et entretenu toute l'année à Payerne.",
            "brand": { "@type": "Brand", "name": "Louati AUTOCENTER Sàrl" },
            "offers": [
              {
                "@type": "Offer",
                "name": "CleanPass Essential",
                "price": "79",
                "priceCurrency": "CHF",
                "priceSpecification": { "@type": "UnitPriceSpecification", "price": "79", "priceCurrency": "CHF", "unitText": "mois" },
                "availability": "https://schema.org/InStock"
              },
              {
                "@type": "Offer",
                "name": "CleanPass Plus",
                "price": "149",
                "priceCurrency": "CHF",
                "priceSpecification": { "@type": "UnitPriceSpecification", "price": "149", "priceCurrency": "CHF", "unitText": "mois" },
                "availability": "https://schema.org/InStock"
              },
              {
                "@type": "Offer",
                "name": "CleanPass Elite",
                "price": "249",
                "priceCurrency": "CHF",
                "priceSpecification": { "@type": "UnitPriceSpecification", "price": "249", "priceCurrency": "CHF", "unitText": "mois" },
                "availability": "https://schema.org/InStock"
              }
            ]
          }
        ]}
      />
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-[50vh] sm:min-h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/c804d52550702abc2b171a77695467d3.jpg"
            alt="CleanPass - Programme d'abonnement entretien véhicule"
            className="w-full h-full object-cover object-center"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
        </div>

        <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl mx-auto">
          <h1 className="font-serif text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-4 sm:mb-6 leading-tight drop-shadow-2xl">
            CleanPass
          </h1>
          <p className="text-lg sm:text-2xl md:text-3xl text-gray-100 mb-6 sm:mb-8 max-w-3xl mx-auto leading-relaxed drop-shadow-lg">
            Votre abonnement entretien véhicule
          </p>
          <button
            onClick={() => setIsModalOpen(true)}
            className="px-6 sm:px-8 py-3 sm:py-4 bg-primary text-dark-bg rounded-lg font-semibold text-base sm:text-lg hover:bg-primary/90 transition-all hover:scale-105 whitespace-nowrap shadow-xl cursor-pointer touch-manipulation"
          >
            Demander un abonnement CleanPass
          </button>
        </div>
      </section>

      {/* Présentation */}
      <section className="py-14 sm:py-24 bg-dark-card">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-6 sm:mb-8">
              Qu'est-ce que CleanPass ?
            </h2>
            <p className="text-gray-300 text-lg leading-relaxed mb-8">
              CleanPass est notre programme d'abonnement conçu pour garder votre véhicule propre et entretenu toute l'année. Grâce à CleanPass, vous bénéficiez d'un entretien régulier de votre véhicule à un tarif avantageux ainsi que de privilèges exclusifs chez Louati Autocenter.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mt-8 sm:mt-12">
              <div className="bg-dark-bg border border-dark-border rounded-2xl p-5 sm:p-8 hover:shadow-xl transition-all duration-300 touch-manipulation">
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-primary/20 flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className="ri-car-washing-line text-2xl sm:text-3xl text-primary"></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3">Véhicule toujours propre</h3>
                <p className="text-gray-400 text-sm sm:text-base">Votre véhicule reste impeccable toute l'année grâce à un entretien régulier</p>
              </div>

              <div className="bg-dark-bg border border-dark-border rounded-2xl p-5 sm:p-8 hover:shadow-xl transition-all duration-300 touch-manipulation">
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-accent-sky/20 flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className="ri-price-tag-3-line text-2xl sm:text-3xl text-accent-sky"></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3">Tarifs avantageux</h3>
                <p className="text-gray-400 text-sm sm:text-base">Économisez sur vos prestations avec des tarifs préférentiels</p>
              </div>

              <div className="bg-dark-bg border border-dark-border rounded-2xl p-5 sm:p-8 hover:shadow-xl transition-all duration-300 touch-manipulation">
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-accent-gold/20 flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className="ri-vip-crown-line text-2xl sm:text-3xl text-accent-gold"></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3">Priorité sur les rendez-vous</h3>
                <p className="text-gray-400 text-sm sm:text-base">Réservez vos créneaux en priorité et bénéficiez d'une flexibilité maximale</p>
              </div>

              <div className="bg-dark-bg border border-dark-border rounded-2xl p-5 sm:p-8 hover:shadow-xl transition-all duration-300 touch-manipulation">
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-accent-peach/20 flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <i className="ri-percent-line text-2xl sm:text-3xl text-accent-peach"></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3">Réductions exclusives</h3>
                <p className="text-gray-400 text-sm sm:text-base">Profitez de réductions sur certains services detailing</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Formules */}
      <section className="py-14 sm:py-24 bg-dark-bg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-3 sm:mb-4">
              Nos Formules CleanPass
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Choisissez la formule qui correspond le mieux à vos besoins
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {/* Essential */}
            <div className="bg-dark-card border border-dark-border rounded-2xl p-6 sm:p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 touch-manipulation">
              <div className="text-center mb-5 sm:mb-6">
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-2">CleanPass Essential</h3>
                <div className="text-3xl sm:text-4xl font-bold text-primary mb-2">
                  79 CHF<span className="text-base sm:text-lg text-gray-400">/mois</span>
                </div>
                <p className="text-gray-500 text-sm">À partir de</p>
              </div>

              <div className="space-y-4 mb-6 sm:mb-8">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-primary text-xl mt-1"></i>
                  <div>
                    <p className="text-white font-semibold text-sm sm:text-base">Chaque mois :</p>
                    <p className="text-gray-400 text-sm">1 nettoyage Express intérieur + extérieur</p>
                  </div>
                </div>
              </div>

              <div className="border-t border-dark-border pt-5 sm:pt-6 space-y-3">
                <p className="text-white font-semibold mb-3 text-sm sm:text-base">Avantages :</p>
                <div className="flex items-center gap-3">
                  <i className="ri-star-fill text-accent-gold text-lg flex-shrink-0"></i>
                  <p className="text-gray-400 text-sm">Priorité de réservation</p>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-percent-line text-accent-gold text-lg flex-shrink-0"></i>
                  <p className="text-gray-400 text-sm">-10 % sur les autres prestations</p>
                </div>
              </div>

              <button
                onClick={() => {
                  setFormData(prev => ({ ...prev, formule: 'Essential' }));
                  setIsModalOpen(true);
                }}
                className="w-full mt-6 sm:mt-8 px-6 py-3 bg-dark-bg border-2 border-primary text-primary rounded-lg font-semibold hover:bg-primary hover:text-dark-bg transition-all whitespace-nowrap cursor-pointer touch-manipulation text-sm sm:text-base"
              >
                Choisir Essential
              </button>
            </div>

            {/* Plus - Populaire */}
            <div className="bg-dark-card border-2 border-primary rounded-2xl p-6 sm:p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 relative touch-manipulation mt-4 sm:mt-0">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-primary text-dark-bg px-4 py-1 rounded-full text-xs sm:text-sm font-bold whitespace-nowrap">
                  LE PLUS POPULAIRE
                </span>
              </div>

              <div className="text-center mb-5 sm:mb-6 mt-4">
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-2">CleanPass Plus</h3>
                <div className="text-3xl sm:text-4xl font-bold text-primary mb-2">
                  149 CHF<span className="text-base sm:text-lg text-gray-400">/mois</span>
                </div>
                <p className="text-gray-500 text-sm">À partir de</p>
              </div>

              <div className="space-y-4 mb-6 sm:mb-8">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-primary text-xl mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-white font-semibold text-sm sm:text-base">Chaque mois :</p>
                    <p className="text-gray-400 text-sm">1 nettoyage Express intérieur + extérieur</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-primary text-xl mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-white font-semibold text-sm sm:text-base">Tous les 3 mois :</p>
                    <p className="text-gray-400 text-sm">1 nettoyage intérieur approfondi</p>
                  </div>
                </div>
              </div>

              <div className="border-t border-dark-border pt-5 sm:pt-6 space-y-3">
                <p className="text-white font-semibold mb-3 text-sm sm:text-base">Avantages :</p>
                <div className="flex items-center gap-3">
                  <i className="ri-star-fill text-accent-gold text-lg flex-shrink-0"></i>
                  <p className="text-gray-400 text-sm">Priorité de réservation</p>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-percent-line text-accent-gold text-lg flex-shrink-0"></i>
                  <p className="text-gray-400 text-sm">-15 % sur les prestations detailing</p>
                </div>
              </div>

              <button
                onClick={() => {
                  setFormData(prev => ({ ...prev, formule: 'Plus' }));
                  setIsModalOpen(true);
                }}
                className="w-full mt-6 sm:mt-8 px-6 py-3 bg-primary text-dark-bg rounded-lg font-semibold hover:bg-primary/90 transition-all whitespace-nowrap cursor-pointer touch-manipulation text-sm sm:text-base"
              >
                Choisir Plus
              </button>
            </div>

            {/* Elite */}
            <div className="bg-dark-card border border-dark-border rounded-2xl p-6 sm:p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 touch-manipulation sm:col-span-2 lg:col-span-1">
              <div className="text-center mb-5 sm:mb-6">
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-2">CleanPass Elite</h3>
                <div className="text-3xl sm:text-4xl font-bold text-primary mb-2">
                  249 CHF<span className="text-base sm:text-lg text-gray-400">/mois</span>
                </div>
                <p className="text-gray-500 text-sm">À partir de</p>
              </div>

              <div className="space-y-4 mb-6 sm:mb-8">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-primary text-xl mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-white font-semibold text-sm sm:text-base">Chaque mois :</p>
                    <p className="text-gray-400 text-sm">1 nettoyage approfondi intérieur ou extérieur</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-primary text-xl mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-white font-semibold text-sm sm:text-base">Chaque mois :</p>
                    <p className="text-gray-400 text-sm">1 nettoyage Express extérieur</p>
                  </div>
                </div>
              </div>

              <div className="border-t border-dark-border pt-5 sm:pt-6 space-y-3">
                <p className="text-white font-semibold mb-3 text-sm sm:text-base">Avantages :</p>
                <div className="flex items-center gap-3">
                  <i className="ri-vip-crown-fill text-accent-gold text-lg flex-shrink-0"></i>
                  <p className="text-gray-400 text-sm">Priorité maximale pour les rendez-vous</p>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-percent-line text-accent-gold text-lg flex-shrink-0"></i>
                  <p className="text-gray-400 text-sm">-20 % sur toutes les prestations</p>
                </div>
              </div>

              <button
                onClick={() => {
                  setFormData(prev => ({ ...prev, formule: 'Elite' }));
                  setIsModalOpen(true);
                }}
                className="w-full mt-6 sm:mt-8 px-6 py-3 bg-dark-bg border-2 border-primary text-primary rounded-lg font-semibold hover:bg-primary hover:text-dark-bg transition-all whitespace-nowrap cursor-pointer touch-manipulation text-sm sm:text-base"
              >
                Choisir Elite
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Conditions */}
      <section className="py-14 sm:py-24 bg-dark-card">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4">
              Conditions
            </h2>
          </div>

          <div className="bg-dark-bg border border-dark-border rounded-2xl p-5 sm:p-8">
            <div className="space-y-5 sm:space-y-6">
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-check-line text-xl sm:text-2xl text-primary"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-white mb-1 sm:mb-2">Engagement minimum</h3>
                  <p className="text-gray-400 text-sm sm:text-base">6 mois d'abonnement</p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-accent-sky/20 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-xl sm:text-2xl text-accent-sky"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-white mb-1 sm:mb-2">Réservation obligatoire</h3>
                  <p className="text-gray-400 text-sm sm:text-base">Prenez rendez-vous pour chaque prestation incluse dans votre abonnement</p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-accent-gold/20 flex items-center justify-center flex-shrink-0">
                  <i className="ri-car-line text-xl sm:text-2xl text-accent-gold"></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-white mb-1 sm:mb-2">Prix selon catégorie</h3>
                  <p className="text-gray-400 text-sm sm:text-base">Les tarifs varient selon la catégorie de votre véhicule (citadine, berline, SUV)</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-14 sm:py-24 bg-dark-bg">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
            Prêt à rejoindre CleanPass ?
          </h2>
          <p className="text-gray-400 text-lg mb-6 sm:mb-8 max-w-2xl mx-auto">
            Demandez votre abonnement dès maintenant et profitez d'un véhicule toujours impeccable
          </p>
          <button
            onClick={() => setIsModalOpen(true)}
            className="inline-flex items-center gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-primary text-dark-bg rounded-lg font-semibold text-base sm:text-lg hover:bg-primary/90 transition-all hover:scale-105 whitespace-nowrap shadow-xl cursor-pointer touch-manipulation"
          >
            <i className="ri-vip-crown-line text-xl"></i>
            Demander un abonnement CleanPass
          </button>
        </div>
      </section>

      <Footer />

      {/* Modal Formulaire */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/80 flex items-start sm:items-center justify-center z-50 p-3 sm:p-4 overflow-y-auto">
          <div className="bg-dark-card border border-dark-border rounded-2xl max-w-2xl w-full my-4 sm:my-8">
            <div className="p-5 sm:p-8">
              <div className="flex justify-between items-center mb-5 sm:mb-6">
                <h3 className="text-lg sm:text-2xl font-bold text-white leading-tight pr-4">Demande d'abonnement CleanPass</h3>
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-dark-bg hover:bg-dark-border transition-colors flex items-center justify-center cursor-pointer touch-manipulation flex-shrink-0"
                >
                  <i className="ri-close-line text-xl sm:text-2xl text-gray-400"></i>
                </button>
              </div>

              <form onSubmit={handleSubmit} id="cleanpass-form" data-readdy-form>
                <div className="space-y-3 sm:space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div>
                      <label className="block text-xs sm:text-sm font-semibold text-gray-300 mb-1 sm:mb-2">
                        Prénom *
                      </label>
                      <input
                        type="text"
                        name="prenom"
                        value={formData.prenom}
                        onChange={handleInputChange}
                        required
                        className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-dark-bg border border-dark-border rounded-lg text-white text-sm focus:outline-none focus:border-primary transition-colors"
                      />
                    </div>
                    <div>
                      <label className="block text-xs sm:text-sm font-semibold text-gray-300 mb-1 sm:mb-2">
                        Nom *
                      </label>
                      <input
                        type="text"
                        name="nom"
                        value={formData.nom}
                        onChange={handleInputChange}
                        required
                        className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-dark-bg border border-dark-border rounded-lg text-white text-sm focus:outline-none focus:border-primary transition-colors"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div>
                      <label className="block text-xs sm:text-sm font-semibold text-gray-300 mb-1 sm:mb-2">
                        Téléphone *
                      </label>
                      <input
                        type="tel"
                        name="telephone"
                        value={formData.telephone}
                        onChange={handleInputChange}
                        required
                        className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-dark-bg border border-dark-border rounded-lg text-white text-sm focus:outline-none focus:border-primary transition-colors"
                      />
                    </div>
                    <div>
                      <label className="block text-xs sm:text-sm font-semibold text-gray-300 mb-1 sm:mb-2">
                        Email *
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-dark-bg border border-dark-border rounded-lg text-white text-sm focus:outline-none focus:border-primary transition-colors"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div>
                      <label className="block text-xs sm:text-sm font-semibold text-gray-300 mb-1 sm:mb-2">
                        Marque du véhicule *
                      </label>
                      <input
                        type="text"
                        name="marque"
                        value={formData.marque}
                        onChange={handleInputChange}
                        required
                        className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-dark-bg border border-dark-border rounded-lg text-white text-sm focus:outline-none focus:border-primary transition-colors"
                      />
                    </div>
                    <div>
                      <label className="block text-xs sm:text-sm font-semibold text-gray-300 mb-1 sm:mb-2">
                        Modèle du véhicule *
                      </label>
                      <input
                        type="text"
                        name="modele"
                        value={formData.modele}
                        onChange={handleInputChange}
                        required
                        className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-dark-bg border border-dark-border rounded-lg text-white text-sm focus:outline-none focus:border-primary transition-colors"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div>
                      <label className="block text-xs sm:text-sm font-semibold text-gray-300 mb-1 sm:mb-2">
                        Catégorie du véhicule *
                      </label>
                      <select
                        name="categorie"
                        value={formData.categorie}
                        onChange={handleInputChange}
                        required
                        className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-dark-bg border border-dark-border rounded-lg text-white text-sm focus:outline-none focus:border-primary transition-colors"
                      >
                        <option value="">Sélectionnez une catégorie</option>
                        <option value="Citadine">Citadine</option>
                        <option value="Berline">Berline</option>
                        <option value="SUV">SUV</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-xs sm:text-sm font-semibold text-gray-300 mb-1 sm:mb-2">
                        Formule souhaitée *
                      </label>
                      <select
                        name="formule"
                        value={formData.formule}
                        onChange={handleInputChange}
                        required
                        className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-dark-bg border border-dark-border rounded-lg text-white text-sm focus:outline-none focus:border-primary transition-colors"
                      >
                        <option value="">Sélectionnez une formule</option>
                        <option value="Essential">Essential (79 CHF/mois)</option>
                        <option value="Plus">Plus (149 CHF/mois)</option>
                        <option value="Elite">Elite (249 CHF/mois)</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs sm:text-sm font-semibold text-gray-300 mb-1 sm:mb-2">
                      Message ou commentaire
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      rows={3}
                      maxLength={500}
                      className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-dark-bg border border-dark-border rounded-lg text-white text-sm focus:outline-none focus:border-primary transition-colors resize-none"
                      placeholder="Informations complémentaires..."
                    ></textarea>
                    <p className="text-xs text-gray-500 mt-1">Maximum 500 caractères</p>
                  </div>
                </div>

                {submitStatus === 'success' && (
                  <div className="mt-4 sm:mt-6 p-3 sm:p-4 bg-primary/20 border border-primary rounded-lg">
                    <p className="text-primary font-semibold flex items-center gap-2 text-sm sm:text-base">
                      <i className="ri-checkbox-circle-fill"></i>
                      Votre demande a été envoyée avec succès ! Nous vous contacterons rapidement.
                    </p>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="mt-4 sm:mt-6 p-3 sm:p-4 bg-red-500/20 border border-red-500 rounded-lg">
                    <p className="text-red-500 font-semibold flex items-center gap-2 text-sm sm:text-base">
                      <i className="ri-error-warning-fill"></i>
                      Une erreur est survenue. Veuillez réessayer.
                    </p>
                  </div>
                )}

                <div className="mt-5 sm:mt-8 flex gap-3 sm:gap-4">
                  <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="flex-1 px-4 sm:px-6 py-2.5 sm:py-3 bg-dark-bg border border-dark-border text-gray-300 rounded-lg font-semibold hover:bg-dark-border transition-all whitespace-nowrap cursor-pointer touch-manipulation text-sm sm:text-base"
                  >
                    Annuler
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="flex-1 px-4 sm:px-6 py-2.5 sm:py-3 bg-primary text-dark-bg rounded-lg font-semibold hover:bg-primary/90 transition-all whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer touch-manipulation text-sm sm:text-base"
                  >
                    {isSubmitting ? 'Envoi...' : 'Envoyer la demande'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CleanPassPage;